// app/javascript/modules/admissoes/defaults_api.js

export function initDefaultsApi($j, $form, h, api, opts = {}) {
  const { hide, setChecked } = h

  function applyDefaults(data) {
    if (!data || data.erro === "Condominio nao localizado") return

    // --- Assistencia Medica / Odontologica / Bem Mais ---
    const temMedica    = data.empresa_medica !== "" && data.empresa_medica != null
    const temOdonto    = data.empresa_odontologica !== "" && data.empresa_odontologica != null
    const enviaBemMais = data.envia_bem_mais === true

    if (enviaBemMais) {
      // Exibe Bem Mais, oculta saude convencional
      const $bemMaisSection = $form.find("#secao-bem-mais")
      if ($bemMaisSection.length) $bemMaisSection.removeClass("hidden")

      const $saudeSection = $form.find("#secao-saude")
      if ($saudeSection.length) hide($saudeSection)
    } else {
      if (temMedica) {
        setChecked("#params_assistencia_medica_sim", true)
        const $nomeMedica = $form.find("#empresa-medica-nome")
        if ($nomeMedica.length) $nomeMedica.text(`Plano: ${data.empresa_medica}`).removeClass("hidden")
      } else if (temOdonto) {
        const $nomeMedica = $form.find("#empresa-medica-nome")
        if ($nomeMedica.length) $nomeMedica.text("Não informado").removeClass("hidden")
      }

      if (temOdonto) {
        setChecked("#params_assistencia_odontologica_sim", true)
        const $nomeOdonto = $form.find("#empresa-odontologica-nome")
        if ($nomeOdonto.length) $nomeOdonto.text(`Plano: ${data.empresa_odontologica}`).removeClass("hidden")
      } else if (temMedica) {
        const $nomeOdonto = $form.find("#empresa-odontologica-nome")
        if ($nomeOdonto.length) $nomeOdonto.text("Não informado").removeClass("hidden")
      }

      // Se nao tem NENHUM plano de saude, esconde a secao inteira de Saude
      if (!temMedica && !temOdonto) {
        const $saudeSection = $form.find("#secao-saude")
        if ($saudeSection.length) hide($saudeSection)
      }
    }

    // --- Contrato de experiencia ---
    const $select = $form.find("#params_contrato_experiencia")
    if ($select.length) {
      let optionExists = false

      $select.find("option").each(function () {
        if ($j(this).val() === data.contrato_experiencia) {
          optionExists = true
          $j(this).text(`${data.contrato_experiencia} (opção padrão)`)
          return false
        }
      })

      if (!optionExists && data.contrato_experiencia) {
        $select.append(`<option value="${data.contrato_experiencia}">${data.contrato_experiencia} (opção padrão)</option>`)
      }

      if (data.contrato_experiencia) $select.val(data.contrato_experiencia)
    }

    // --- Contrato Digital: relaxa obrigatoriedade de horario, foto e escala ---
    if (!data.contrato_digital) {
      const removeRequired = ($el) => {
        $el.prop("required", false).removeAttr("required").removeAttr("aria-required")
        // Oculta o asterisco (*) que simple_form renderiza como <abbr> no label
        $el.each(function() {
          const id = $j(this).attr('id')
          if (id) $form.find(`label[for="${id}"] abbr`).hide()
        })
      }

      removeRequired($form.find("select#params_escala, select[name='params[escala]']"))
      removeRequired($form.find("select#params_horario, select[name='params[horario]']"))
      removeRequired($form.find("input[name='movimentacoes_pessoal[foto]']"))
      // identidade permanece obrigatória em qualquer modalidade de contrato
    }

    // --- Label da empresa de benefícios ---
    const empresaBeneficios = data.empresa_beneficios || data.empresa_ticket
    if (empresaBeneficios) {
      const tipo = empresaBeneficios.charAt(0).toUpperCase() + empresaBeneficios.slice(1)
      const $tipoLabel = $form.find("#va-tipo-label")
      if ($tipoLabel.length) $tipoLabel.text(`(${tipo})`)
    }

    // --- Controle granular de benefícios alimentares ---
    const possuiVa         = data.possui_va
    const possuiVr         = data.possui_vr
    const possuiCestaBasica = data.possui_cesta_basica

    const $secaoVa   = $form.find("#secao-va")
    const $secaoVr   = $form.find("#secao-vr")
    const $secaoCesta = $form.find("#secao-cesta-basica")

    // VA
    if (possuiVa === "N") {
      if ($secaoVa.length) hide($secaoVa)
    }

    // VR
    if (possuiVr === "N") {
      if ($secaoVr.length) hide($secaoVr)
    }

    // Cesta Básica — visível apenas se explicitamente "S"
    if (possuiCestaBasica === "S") {
      if ($secaoCesta.length) $secaoCesta.css("display", "")
    } else {
      if ($secaoCesta.length) hide($secaoCesta)
    }

    // Fallback legado: se a API retornar apenas possui_va sem os granulares, esconde VA e VR
    if (possuiVa === "N" && possuiVr == null && possuiCestaBasica == null) {
      if ($secaoVr.length) hide($secaoVr)
    }

    if (data.possui_vt === "N") {
      hide($form.find(".params_meio_de_transporte_ida"))
      hide($form.find("#adicionar_campo_meio_de_transporte_ida"))
      hide($form.find(".params_valor_meio_de_transporte_ida"))
      hide($form.find("#adicionar_campo_meio_de_transporte_volta"))
      hide($form.find(".params_valor_meio_de_transporte_volta"))
      hide($form.find("#adicionarCampoIda"))
      hide($form.find(".params_meio_de_transporte_volta"))
      hide($form.find(".params_meio_de_transporte_volta_valor"))
      hide($form.find("#adicionarCampoVolta"))
      hide($form.find(".params_possui_vale_transporte"))
      hide($form.find(".possui_cartao_bilhete_unico"))
      hide($form.find(".esta_desvinculado_da_empresa_anterior"))
      hide($form.find(".numero_cartao_vale_transporte"))
    }

    // --- Pré-selecionar tipo (Mensal/Diário) e preencher valor para cada benefício ---

    // VA (alimentação)
    if (possuiVa !== "N") {
      _preencherTicket({
        tipoApi:   data.tipo_va,
        valorApi:  data.valor_vale_alimentacao,
        radioName: "params[ticket_alimentacao]",
        valorId:   "#params_valor_ticket_alimentacao",
      })
      _preCheckarDesconta(data.desconta_va_contra_cheque, "params[desconta_alimentacao_em_contracheque]")
      _preencherDesconto({
        tipoDescontoApi: data.tipo_desconto_va,
        valorDescontoApi: data.valor_desconto_va,
        tipoRadioName: "params[tipo_desconto_alimentacao]",
        valorId: "#params_desconto_alimentacao",
      })
    }

    // VR (refeição)
    if (possuiVr !== "N") {
      const valorVr = (data.valor_vale_refeicao != null && data.valor_vale_refeicao !== "0,00" && data.valor_vale_refeicao !== "" && data.valor_vale_refeicao !== false)
        ? data.valor_vale_refeicao
        : data.valor_vale_alimentacao
      _preencherTicket({
        tipoApi:   data.tipo_vr,
        valorApi:  valorVr,
        radioName: "params[ticket_refeicao]",
        valorId:   "#params_valor_ticket_refeicao",
      })
      _preCheckarDesconta(data.desconta_vr_contra_cheque, "params[desconta_refeicao_em_contracheque]")
      _preencherDesconto({
        tipoDescontoApi: data.tipo_desconto_vr,
        valorDescontoApi: data.valor_desconto_vr,
        tipoRadioName: "params[tipo_desconto_refeicao]",
        valorId: "#params_desconto_refeicao",
      })
    }

    // Cesta Básica — campo correto da API é "tipo_cesta" (não "tipo_cesta_basica")
    if (possuiCestaBasica === "S") {
      _preencherTicket({
        tipoApi:   data.tipo_cesta,
        valorApi:  data.valor_cesta_basica,
        radioName: "params[ticket_cesta_basica]",
        valorId:   "#params_valor_ticket_cesta_basica",
      })
      _preCheckarDesconta(data.desconta_cesta_basica_contra_cheque, "params[desconta_cesta_basica_em_contracheque]")
      _preencherDesconto({
        tipoDescontoApi: data.tipo_desconto_cesta_basica,
        valorDescontoApi: data.valor_desconto_cesta_basica,
        tipoRadioName: "params[tipo_desconto_cesta_basica]",
        valorId: "#params_desconto_cesta_basica",
      })
    }

    // --- Adiantamento ---
    const percentualAdiantamento = data.percentual_adiantamento
    // Usa comparação estrita para não confundir false (API sem dado) com 0 (percentual zero)
    if (percentualAdiantamento == null || percentualAdiantamento === "" || percentualAdiantamento === 0) {
      // Condomínio não pratica adiantamento — oculta a seção e exibe aviso abaixo do salário
      const $secaoAdiantamento = $form.find("#secao-adiantamento")
      if ($secaoAdiantamento.length) hide($secaoAdiantamento)
      const $semAdiantamentoInfo = $form.find("#sem-adiantamento-info")
      if ($semAdiantamentoInfo.length) $semAdiantamentoInfo.removeClass("hidden")
    } else {
      const $pct = $form.find("#params_percentual_adiantamento")
      if ($pct.length) {
        $pct.data("percentual-condominio", percentualAdiantamento)
        if (!($pct.val() || "").trim()) $pct.val(percentualAdiantamento)
      }
    }

    // --- Vale Combustível ---
    if (data.possui_beneficio_combustivel === true) {
      const $combustivelSection = $form.find("#secao-combustivel")
      if ($combustivelSection.length) $combustivelSection.removeClass("hidden")

      if (data.empresa_ticket_combustivel) {
        const $label = $form.find("#combustivel-empresa-label")
        if ($label.length) $label.text(`(${data.empresa_ticket_combustivel})`)
      }
    }
  }

  // Pré-seleciona tipo de ticket (Mensal/Diário) e preenche valor
  function _preencherTicket({ tipoApi, valorApi, radioName, valorId }) {
    const $group = $form.find(`input[name="${radioName}"]`)
    if (!$group.length) return

    const jaTemSelecionado = $group.filter(":checked").length > 0

    if (!jaTemSelecionado && tipoApi) {
      // Normaliza: "mensal" → "Mensal", "diario"/"diário" → "Diário"
      const tipoNorm = tipoApi.toLowerCase().includes("mensal") ? "Mensal" : "Diário"
      $group.filter(`[value="${tipoNorm}"]`).prop("checked", true)
    }

    if (valorApi != null && valorApi !== "0,00" && valorApi !== "") {
      const $input = $form.find(valorId)
      if ($input.length && !($input.val() || "").trim()) {
        $input.val(valorApi)
      }
    }
  }

  // Pré-marca o radio de "desconta em contracheque" com base no flag da API ("S" → "Sim")
  function _preCheckarDesconta(flagApi, radioName) {
    if (flagApi == null) return
    const valor = flagApi === "S" ? "Sim" : "Não"
    const $radio = $form.find(`input[name="${radioName}"][value="${valor}"]`)
    if ($radio.length && !$form.find(`input[name="${radioName}"]:checked`).length) {
      $radio.prop("checked", true).trigger("change")
    }
  }

  // Pré-seleciona tipo de desconto e preenche o valor do desconto
  // tipoDescontoApi: "valor" → "Valor (R$)" | "percentual" → "Percentual (%)"
  function _preencherDesconto({ tipoDescontoApi, valorDescontoApi, tipoRadioName, valorId }) {
    if (tipoDescontoApi == null) return

    const tipoLabel = tipoDescontoApi.toLowerCase().includes("percentual") ? "Percentual (%)" : "Valor (R$)"
    const $tipoRadio = $form.find(`input[name="${tipoRadioName}"][value="${tipoLabel}"]`)

    if ($tipoRadio.length && !$form.find(`input[name="${tipoRadioName}"]:checked`).length) {
      $tipoRadio.prop("checked", true).trigger("change")
    }

    if (valorDescontoApi != null && valorDescontoApi !== "" && valorDescontoApi !== false) {
      const $input = $form.find(valorId)
      if ($input.length && !($input.val() || "").trim()) {
        // Formata para o padrão BR que a máscara espera ("1.60" → "1,60")
        const formatted = String(valorDescontoApi).replace(".", ",")
        $input.val(formatted)
      }
    }
  }

  function fetch() {
    if (!api.defaultsUrl) return
    $j.ajax({
      url: api.defaultsUrl,
      type: "GET",
      success: (data) => {
        applyDefaults(data)
        if (opts.afterApply) opts.afterApply()
      },
      error: (_jqXHR, textStatus, errorThrown) => {
        console.error("AJAX request failed:", textStatus, errorThrown)
      },
    })
  }

  fetch()
  return { destroy() { } }
}
